// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__xIT9Z","additionalInfo":"AgreementModal_additionalInfo__3-cIh"};